import React, { useEffect, useState } from "react";
import { updateFn } from "./events";
import { SelectedItem } from "./selected-item";
import classnames from "classnames";
import { checkMultiMatch, setDefaultArrayValue } from "../typeahead/lib/check-match";
import * as notify from "../../../shared/notify";

const ListOf = (Input) => (props) => {
    // TODO: FIX!!!
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [values, setValues] = useState(setDefaultArrayValue(props.defaultValue));
    // TODO: FIX!!!
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [currentValue, setCurrentValue] = useState("");

    // TODO: FIX!!!
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        const isMatch = checkMultiMatch(props.defaultValue, values);

        if (!isMatch) {
            setValues(setDefaultArrayValue(props.defaultValue));
        }
    }, [props.defaultValue]);

    // TODO: FIX!!!
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        if (props.disabled) {
            setCurrentValue("");
        }
    }, [props.disabled]);

    const reportUp = (v) => {
        if (props.onChange) {
            props.onChange(props.name, v);
        }

        if (props.updateOnChange) {
            props.updateOnChange(props.name, v);
        }
    };

    const onClickAdd = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!currentValue || currentValue.trim().length < 1) {
            notify.error("please enter a value");

            return;
        }

        const vals = [...values, currentValue];

        setCurrentValue("");
        setValues(vals);
        reportUp(vals);
    };

    const removeValue = (index) => {
        const newValues = [...values];
        newValues.splice(index, 1);
        setValues(newValues);

        reportUp(newValues);
    };

    const aggregateValues = (name, value) => {
        setCurrentValue(value);
    };

    const handleEnter = (e) => {
        if (e.which === 13 || e.keyCode === 13) {
            onClickAdd(e);

            return false;
        }
    };

    const updateValues = (index, value) => {
        const newValues = [...values];
        newValues.splice(index, 1, value);
        setValues(newValues);
        reportUp(newValues);
    };

    const selected =
        values && values.length > 0
            ? values.map((value, index) => {
                  const isEditable = typeof value === "string" ? true : false;

                  return (
                      <SelectedItem
                          key={`${props.name}_${index}of${values.length}`}
                          name={`${props.name}_${index}of${values.length}`}
                          index={index}
                          code={value}
                          text={value.trim()}
                          isEditable={isEditable}
                          removeValue={removeValue}
                          updateValues={updateValues}
                          spellingErrors={props.spellingErrors}
                          disabled={props.disabled}
                          maxLength={props.maxLength}
                      />
                  );
              })
            : null;

    return (
        <div key={`listOf_${props.name}`} id={`listOf_${props.name}`}>
            <div>{selected}</div>
            <div className="input-group">
                <Input
                    key={`${props.id || props.name}`}
                    id={`${props.id || props.name}`}
                    name={props.name}
                    autoComplete={props.autoComplete}
                    autoFocus={props.autoFocus}
                    min={props.min}
                    max={props.max}
                    maxLength={props.maxLength}
                    minLength={props.minLength}
                    multiple={props.multiple}
                    pattern={props.pattern}
                    placeholder={props.placeholder}
                    readOnly={props.readOnly}
                    required={props.required}
                    step={props.step}
                    value={currentValue}
                    onKeyPress={handleEnter}
                    onKeyUp={props.onKeyUp}
                    updateOnChange={aggregateValues}
                    onBlur={props.onBlur || updateFn(props.updateOnBlur)}
                    onFocus={props.onFocus}
                    disabled={props.disabled}
                    tabIndex={props.tabIndex}
                    className={classnames({ "-error": props.invalid })}
                />
                <button className="button -primary" onClick={onClickAdd} disabled={props.disabled}>
                    +
                </button>
            </div>
        </div>
    );
};

export default ListOf;
